import styled from "styled-components";

export const CriteriaWrapper = styled.div`
  display: grid;
  grid-template-columns: 47.5% 47.5%;
  column-gap: 5%;
  row-gap: 30px;
`;
